module.exports = __webpack_public_path__ + "static/media/logoku.9a30ce85.png";